<template>
    <div>
        <b-button v-if="noteText" class="align-baseline pb-0 with-text" @click="handleNoteClick" variant="link">
            <font-awesome-icon size="lg" :icon="['fas', 'note-sticky']" />
        </b-button>
        <b-button v-else class="align-baseline pb-0" @click="handleNoteClick" variant="link">
            <font-awesome-icon size="lg" :icon="['fas', 'note-sticky']" />
        </b-button>
        <modal
            :id="noteModalId"
            title="Other Things to Note"
            ok-title="Save"
            :ok-disabled="loading"
            @ok="handleSaveNote"
            @shown="onModalShown"
            size="lg"
            scrollable
        >
            <busy-modal :show="loading"></busy-modal>
            <b-row>
                <b-col>
                    <form-textarea rows="15" v-model="noteText"></form-textarea>
                </b-col>
            </b-row>
        </modal>
    </div>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';
    import API from '../../../api';
    import { PARTNER_AIRBNB_FEED_SHARE_BY_ID_ENDPOINT } from '../../../endpoints';
    import FormTextarea from '../../generic/form-textarea/form-textarea.vue';
    import Modal from '../../generic/modal/modal.vue';
    import BusyModal from '../../generic/busy-modal/busy-modal.vue';
    import { formatResponseError } from '../../../utils/api';

    export default {
        components: { FormTextarea, Modal, BusyModal },
        data() {
            return { loading: false, noteModalId: '', noteText: '' };
        },
        created() {
            this.feedShare = this.params.data;
            this.noteModalId = `notes-cell-renderer-modal-${this.feedShare.id}`;
            this.noteText = this.params.data.rental_property.notes;
        },
        methods: {
            handleNoteClick() {
                this.$bvModal.show(this.noteModalId);
            },
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            async handleSaveNote() {
                this.loading = true;
                try {
                    await API.patch(PARTNER_AIRBNB_FEED_SHARE_BY_ID_ENDPOINT(this.feedShare.id), {
                        rental_property_notes: this.noteText,
                    });
                } catch (error) {
                    const { generic, fields } = formatResponseError(error);

                    if (generic) {
                        this.errorToast({ text: generic });
                    }
                    if (!generic && !isEmpty(fields)) {
                        this.$refs.note.setErrors(fields);
                    }
                } finally {
                    this.loading = false;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .note-image {
        cursor: pointer;
        height: 25px;
    }

    .with-text.btn-link {
        color: #17a2b7 !important;
    }
</style>
